import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Icon, USER_INTERFACE_ARROW_01 } from '@bwoty-web/styleguide';
import { logToDataLayer } from '../../utils/tracking';
import { getBackgroundImageStyling } from '../../utils/imageUtils';
import { filterStepsTypes } from '../../appSettings';
import './startView.scss';

const StartView = ({
  startViewHeader,
  startViewButtonText,
  startViewBackgroundImages,
  imageDomain,
}) => {
  const navigate = useNavigate();
  const [backgroundImage, setBackgroundImage] = useState(null);

  const handleStart = () => {
    logToDataLayer({
      event: 'vacationfinder',
      eventAction: 'Intro - Click Next',
    });
    navigate(`/${filterStepsTypes.PRIMARY_CLASSIFICATIONS}`);
  };

  useEffect(() => {
    logToDataLayer({ event: 'vacationfinder', eventAction: 'Intro - View' });
  }, []);

  // getting a random background image from the startViewBackgroundImages array
  useEffect(() => {
    const backgroundImages = startViewBackgroundImages.filter(
      (svbi) =>
        svbi?.itemKey.startsWith('startViewBackgroundImage') &&
        svbi?.image.mediaUrl,
    );
    const imageIndex = Math.floor(Math.random() * backgroundImages.length);
    setBackgroundImage(backgroundImages[imageIndex].image);
  }, []);

  return (
    <>
      <style scoped>
        {/* injecting style this way to be able to set different media urls and not have refetching on resizing */}
        {getBackgroundImageStyling(
          'vf-start-view__bg',
          imageDomain,
          backgroundImage,
        )}
      </style>
      <div className="vf-view vf-start-view vf-view vf-start-view__bg">
        <div className="vf-start__content">
          <h2 className="vf-start__header">{startViewHeader}</h2>
          <Button
            theme="primary"
            className="vf-start__button"
            data-test="start-button"
            onClick={handleStart}
          >
            {startViewButtonText}
            <Icon
              className="vf-start__button-icon"
              path={USER_INTERFACE_ARROW_01}
              size="xs"
            />
          </Button>
        </div>
      </div>
    </>
  );
};

StartView.propTypes = {
  startViewHeader: PropTypes.string.isRequired,
  startViewButtonText: PropTypes.string.isRequired,
  startViewBackgroundImages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  imageDomain: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    startViewHeader: state.attributeCollection.startViewHeader,
    startViewButtonText: state.attributeCollection.startViewButtonText,
    startViewBackgroundImages:
      state.attributeCollection.startViewBackgroundImages,
    imageDomain: state.siteSettings.imageUrl,
  };
};

export default connect(mapStateToProps)(StartView);
